<template>
    <v-container>
        <v-card>
            <v-card-title>
                <v-icon left>mdi-account-multiple</v-icon>
                Mitarbeiterliste verwalten
            </v-card-title>
            <v-card-subtitle>
                E-Mail-Adressen der Mitarbeiter, die erweiterte Bestellrechte haben.
            </v-card-subtitle>
            <v-card-text>
                <v-alert v-if="error" type="error" dense dismissible @input="error = ''">
                    {{ error }}
                </v-alert>
                <v-alert v-if="success" type="success" dense dismissible @input="success = ''">
                    {{ success }}
                </v-alert>

                <v-row align="center" class="mb-4">
                    <v-col cols="8" sm="6">
                        <v-text-field v-model="newEmail" label="Neue E-Mail-Adresse" placeholder="name@example.de"
                            :rules="emailRules" outlined dense hide-details="auto"
                            @keyup.enter="addEmail"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="2">
                        <v-btn color="primary" @click="addEmail" :disabled="!isValidEmail">
                            <v-icon left>mdi-plus</v-icon> Hinzufügen
                        </v-btn>
                    </v-col>
                </v-row>

                <v-data-table :headers="headers" :items="emailItems" :search="search" :loading="isLoading"
                    loading-text="Lade Mitarbeiterliste..." no-data-text="Keine Mitarbeiter vorhanden">
                    <template v-slot:top>
                        <v-text-field v-model="search" label="Suchen" prepend-inner-icon="mdi-magnify" outlined dense
                            hide-details class="mb-4"></v-text-field>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-btn icon small color="error" @click="removeEmail(item.email)">
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save" :loading="isSaving" :disabled="!hasChanges">
                    <v-icon left>mdi-content-save</v-icon> Speichern
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import { firestore as db } from "@/plugins/firebase"
import { doc, getDoc, setDoc } from "firebase/firestore"

export default {
    data() {
        return {
            isLoading: false,
            isSaving: false,
            emails: [],
            originalEmails: [],
            newEmail: "",
            search: "",
            error: "",
            success: "",
            headers: [
                { text: "E-Mail-Adresse", value: "email" },
                { text: "Aktionen", value: "actions", sortable: false, width: "100px" }
            ],
            emailRules: [
                v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Ungültige E-Mail-Adresse"
            ]
        }
    },
    computed: {
        emailItems() {
            return this.emails.map(email => ({ email }))
        },
        isValidEmail() {
            return this.newEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.newEmail)
        },
        hasChanges() {
            if (this.emails.length !== this.originalEmails.length) return true
            const sorted1 = [...this.emails].sort()
            const sorted2 = [...this.originalEmails].sort()
            return sorted1.some((e, i) => e !== sorted2[i])
        }
    },
    async mounted() {
        if (!this.$store.state.auth.isSignedIn) {
            this.$router.push("/login")
            return
        }
        await this.loadEmails()
    },
    methods: {
        async loadEmails() {
            this.isLoading = true
            try {
                const docSnap = await getDoc(doc(db, "Einstellungen", "Mitarbeiterliste"))
                if (docSnap.exists()) {
                    this.emails = [...(docSnap.data().emails || [])]
                } else {
                    this.emails = []
                }
                this.originalEmails = [...this.emails]
            } catch (err) {
                console.error("Fehler beim Laden der Mitarbeiterliste:", err)
                this.error = "Fehler beim Laden der Mitarbeiterliste."
            }
            this.isLoading = false
        },
        addEmail() {
            if (!this.isValidEmail) return
            const email = this.newEmail.trim().toLowerCase()
            if (this.emails.includes(email)) {
                this.error = "Diese E-Mail-Adresse ist bereits vorhanden."
                return
            }
            this.emails.push(email)
            this.newEmail = ""
            this.error = ""
        },
        removeEmail(email) {
            this.emails = this.emails.filter(e => e !== email)
        },
        async save() {
            this.isSaving = true
            this.error = ""
            this.success = ""
            try {
                await setDoc(doc(db, "Einstellungen", "Mitarbeiterliste"), {
                    emails: this.emails
                })
                this.originalEmails = [...this.emails]
                this.success = "Mitarbeiterliste wurde gespeichert."
            } catch (err) {
                console.error("Fehler beim Speichern:", err)
                this.error = "Fehler beim Speichern der Mitarbeiterliste."
            }
            this.isSaving = false
        }
    }
}
</script>
